import $ from 'jquery';
import BLazy from 'blazy';
import Cookie from 'js-cookie';
import App, { renderSearchList } from './App';
import { IconBasket, IconWishlist } from './Icons';
import { Alert } from './Alert';
import GetFunction, { Get } from './Get';
import { Validation } from './Validation';
import { Recaptcha } from './Recaptcha';
import { ExpandableBasket } from './ExpandableBasket';
import Bars from './Bars';

import { getProducts, getLowestPrice } from './GraphQL';

import runOmnibusFallback from './Omnibus';

const init = () => {
  /* eslint-disable */
  (function ($) {
    'use strict';
    var backdrop = '.dropdown-backdrop';
    var toggle = '[data-toggle="dropdown"]';
    var Dropdown = function (element) {
      $(element).on('click.bs.dropdown', this.toggle);
    };
    Dropdown.VERSION = '3.3.6';
    function getParent($this) {
      var selector = $this.attr('data-target');
      if (!selector) {
        selector = $this.attr('href');
        selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '');
      }
      var $parent = selector && $(selector);
      return $parent && $parent.length ? $parent : $this.parent();
    }
    function clearMenus(e) {
      if (e && e.which === 3) return;
      $(backdrop).remove();
      $(toggle).each(function () {
        var $this = $(this);
        var $parent = getParent($this);
        var relatedTarget = { relatedTarget: this };
        if (!$parent.hasClass('open')) return;
        if (e && e.type == 'click' && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target))
          return;
        $parent.trigger((e = $.Event('hide.bs.dropdown', relatedTarget)));
        if (e.isDefaultPrevented()) return;
        $this.attr('aria-expanded', 'false');
        $parent.removeClass('open').trigger($.Event('hidden.bs.dropdown', relatedTarget));
      });
    }
    Dropdown.prototype.toggle = function (e) {
      var $this = $(this);
      if ($this.is('.disabled, :disabled')) return;
      var $parent = getParent($this);
      var isActive = $parent.hasClass('open');
      clearMenus();
      if (!isActive) {
        if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
          $(document.createElement('div')).addClass('dropdown-backdrop').insertAfter($(this)).on('click', clearMenus);
        }
        var relatedTarget = { relatedTarget: this };
        $parent.trigger((e = $.Event('show.bs.dropdown', relatedTarget)));
        if (e.isDefaultPrevented()) return;
        $this.trigger('focus').attr('aria-expanded', 'true');
        $parent.toggleClass('open').trigger($.Event('shown.bs.dropdown', relatedTarget));
      }
      return false;
    };
    Dropdown.prototype.keydown = function (e) {
      if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return;
      var $this = $(this);
      e.preventDefault();
      e.stopPropagation();
      if ($this.is('.disabled, :disabled')) return;
      var $parent = getParent($this);
      var isActive = $parent.hasClass('open');
      if ((!isActive && e.which != 27) || (isActive && e.which == 27)) {
        if (e.which == 27) $parent.find(toggle).trigger('focus');
        return $this.trigger('click');
      }
      var desc = ' li:not(.disabled):visible a';
      var $items = $parent.find('.dropdown-menu' + desc);
      if (!$items.length) return;
      var index = $items.index(e.target);
      if (e.which == 38 && index > 0) index--;
      if (e.which == 40 && index < $items.length - 1) index++;
      if (!~index) index = 0;
      $items.eq(index).trigger('focus');
    };
    function Plugin(option) {
      return this.each(function () {
        var $this = $(this);
        var data = $this.data('bs.dropdown');
        if (!data) $this.data('bs.dropdown', (data = new Dropdown(this)));
        if (typeof option == 'string') data[option].call($this);
      });
    }
    var old = $.fn.dropdown;
    $.fn.dropdown = Plugin;
    $.fn.dropdown.Constructor = Dropdown;
    $.fn.dropdown.noConflict = function () {
      $.fn.dropdown = old;
      return this;
    };
    $(document)
      .on('click.bs.dropdown.data-api', clearMenus)
      .on('click.bs.dropdown.data-api', '.dropdown form', function (e) {
        e.stopPropagation();
      })
      .on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle)
      .on('keydown.bs.dropdown.data-api', toggle, Dropdown.prototype.keydown)
      .on('keydown.bs.dropdown.data-api', '.dropdown-menu', Dropdown.prototype.keydown);
  })($);
  /* eslint-enable */
  /* eslint-disable import/prefer-default-export */
  /* eslint-disable prefer-arrow-callback */
  /* eslint-disable camelcase */
  /* eslint-disable no-loop-func */
  /* eslint-disable consistent-return */
  /* eslint-disable no-restricted-globals */
  /* eslint-disable no-plusplus */
  /* eslint-disable no-restricted-syntax */
  /* eslint-disable guard-for-in */
  /* eslint-disable no-undef */
  /* eslint-disable no-eval */
  /* eslint-disable eqeqeq */
  /* eslint-disable prefer-template */

  $('.html-placeholder').each(function placeholderEach() {
    const self = $(this);

    if (self.data('selector') && $(self.data('selector')).length) {
      self.replaceWith($(self.data('selector')));
    }
  });

  $('#menu_orders .headline, #menu_account .headline, #menu_regulations .headline').on(
    'click',
    function footerMenuHeadlineClick() {
      if (App.vars.view === 1) {
        const self = $(this);
        if (self.next().hasClass('footer__sublist')) {
          self.toggleClass('--open');
          self.next().slideToggle('slow');
          return false;
        }
      }
      return true;
    },
  );

  $('.menu__search label').on('click', function menuSearchLabeLClick() {
    $('html').addClass('search_open');
    $('#menu_search input').focus();
  });

  $('.menu__search .--close').on('click', function menuSearchCloseClick() {
    $('#menu_search input').val('');
    $('.menu__search-result').remove();
    $('html').removeClass('search_open');
    return false;
  });

  $('.menu__search .f-control').on('keyup', function menuSearchInputKeyup() {
    const self = this;

    if (self.value.length === 0) {
      $('.menu__search-result').remove();
    }

    if (!$('.menu__search-result').length) {
      const html = '<div class="menu__search-result"></div>';
      $('.menu__search').append(html);
    }

    if (self.value.length >= 4) {
      clearTimeout(App.vars.searchTimeout);

      App.vars.searchTimeout = setTimeout(() => renderSearchList(self.value, '.menu__search-result'), 500);
    } else {
      clearTimeout(App.vars.searchTimeout);
      // eslint-disable-next-line no-undef
      App.vars.searchTimeout = setTimeout(
        () =>
          $('.menu__search-result').html(
            `<div class="--empty d-flex align-items-center justify-content-center" style="min-height: 200px">${Literals.searchMinLength}</div>`,
          ),
        1500,
      );
    }
  });

  $(document).on('keyup blur change', '.f-control.--validate-input', function changeInputValidation() {
    clearTimeout(App.vars.validationTimeout);
    App.vars.validationTimeout = setTimeout(() => Validation.validateInput(this, this.dataset.validate), 500);
  });

  $(document).on('submit', '.--validate-form', function submitValidateForm(event) {
    Validation.validateForm(event, [...this.querySelectorAll('.--validate-input')]);
  });

  $(document).on('click', 'aside .menu__settings .--trigger', function settingsTriggerClick() {
    const self = $(this);
    const next = self.next();
    if (next.length && next.hasClass('menu__settings-form')) {
      $('.menu__helps .--open').removeClass('--open');
      next.toggleClass('--open');
    }
  });

  $(document).on('click', 'aside .menu__helps .--help-toggler', function settingsTriggerClick() {
    const self = $(this);
    const next = self.next();
    if (next.length && next.hasClass('menu__expand')) {
      $('.menu__settings .--open').removeClass('--open');
      next.toggleClass('--open');
    }
  });

  $(document).on('click', 'aside .nav-item > .nav-link', function asideNavLinkClick(e) {
    const self = $(this);
    if (self.next().hasClass('navbar__wrapper')) {
      self.next().scrollTop(0).addClass('--open');
      e.preventDefault();
    }
    if (self.hasClass('--has-child')) {
      self
        .parents('.navbar__wrapper')
        .find(`.navbar-subsubnav[data-child_id=${self.data('child')}]`)
        .scrollTop(0)
        .addClass('--open');
      e.preventDefault();
    }
  });

  $(document).on('click', '.nav-header', function asideNavHeaderClick(e) {
    e.preventDefault();
    $(this).closest('.--open').removeClass('--open');
  });

  $(document).on('click', function clicktoCloseMenuSearchResult(e) {
    if ($('.menu__search-result').length) {
      if (e.target.closest('.menu__search-result')) {
        return true;
      }
      $('.menu__search-result').remove();
    }
    return true;
  });

  $(document).on('mouseenter', 'header .navbar-nav > .nav-item', async function getAjaxProducts() {

    const updateLowestPrice = (lowestPriceData, size, wrapper) => {
      try {
        const priceType = 'gross';
  
        if (!lowestPriceData.sizes.length) return false;
        const lowestPriceElement = wrapper;
        const lowestPriceValueElement = wrapper.find('span');
        const currentSize = size == 'onesize' ? 'uniw' : size;
        if (currentSize) { // Wybrany rozmiar
            lowestPriceValueElement.html(lowestPriceData.sizes.filter((size) => size.id === currentSize)[0]?.price[priceType]?.formatted);
        } else {
            const highestPrice = lowestPriceData.sizes.reduce((prev, current) => (prev.price[priceType].value < current.price[priceType].value ? current : prev));
            const lowestPrice = lowestPriceData.sizes.reduce((prev, current) => (prev.price[priceType].value > current.price[priceType].value ? current : current));
            // Zakres cen
            if (lowestPrice.price[priceType].value !== highestPrice.price[priceType].value) {
                lowestPriceValueElement.html(lowestPrice.price[priceType].formatted + ' - ' + highestPrice.price[priceType].formatted);
            } else { // Jedna cena
                lowestPriceValueElement.html(lowestPrice.price[priceType].formatted);
            }
        }
    
        if (lowestPriceValueElement.html() !== '') {
            lowestPriceElement.addClass('--active');
        } else {
            lowestPriceElement.removeClass('--active');
        }
      } catch (error) {
        wrapper.remove();
        console.log('menuUpdateLowestPriceError: ', error);
      }
    }

    const self = $(this);
    const title = self.find('> .nav-link').attr('title');
    const product = self.find('.product.--ajax');

    if (product.length && !App.vars.ajaxLoad[title]) {
      App.vars.ajaxLoad[title] = true;
      const productList = [];
      $.each(product, (i, elem) => {
        productList.push($(elem).data('product'));
      });

      const products = await getProducts(`
        searchInput: {productsId: [${productList.join(',')}]},
        settingsInput: {
          limit: 99
        }
      `);

      if(!products) return false;

      const productsArr = products.data.products.products;
			if(!Array.isArray(productsArr)) return false;

      productsArr.forEach(async (prod) => {
        const { 
          id, 
          name, 
          price,
          sizes, 
          icon, 
          link, 
          description,
        } = prod;

        const maxPriceFormatted = typeof sizes !== 'undefined' && sizes[0].price?.beforeRebate?.gross?.value ? sizes[0].price?.beforeRebate?.gross?.formatted : false;
        const priceFormatted = typeof sizes !== 'undefined' && sizes[0].price?.price?.gross?.value ? sizes[0].price?.price?.gross?.formatted : false;

        const lowestPriceDate = price?.lastPriceChangeDate;

        let lowestPriceData = null;
        if(lowestPriceDate) {
          lowestPriceData = await getLowestPrice(`lastLowestPricesInput: [{
            date: "${lowestPriceDate}",
            productId: ${id},
          }]`);
        }

        const productHtml = /* html */ `
            <figure class="product__icon">
              <a class="product__icon-link" href="${link}">
                <img src="${icon}" />
              </a>
            </figure>
            <a class="product__name" href="${link}">${name}</a>
            <div class="product__description">
              <p>${description}</p>
            </div>
            <div class="product__details">
              <div class="product__prices">
                ${
                  maxPriceFormatted
                    ? `<del class="price --maxprice">${maxPriceFormatted}</del>`
                    : ''
                }
                <strong class="price">${priceFormatted}</strong>
              </div>
              ${
                lowestPriceDate
                  ? `<div class="product__lowest_price" data-change-date="${lowestPriceDate}">${window.Literals.menuHotspot.lowestPrice} <span></span></div>`
                  : ''
              }
              <div class="product__actions">
                <button type="button" class="btn --solid --cart" data-product="${id}">
                  ${window.Literals.menuHotspot.button}
                </button>
                <button type="button" class="btn --solid --secondary --wishlist" data-mode="2" data-product="${id}">
                  ${IconWishlist}
                </button>
              </div>
            </div>
          `;

          const currentProduct = self.find(`.product.--ajax[data-product="${id}"]`);
          currentProduct.html(productHtml);

          if (lowestPriceData?.data?.getLastLowestProductPrices) {
            updateLowestPrice(lowestPriceData.data.getLastLowestProductPrices[0], sizes[0].id, currentProduct.find('.product__lowest_price'));
          }

          currentProduct.removeClass('--ajax').addClass('--loaded');
      });

      // product.removeClass('--ajax').addClass('--loaded');
      App.vars.ajaxLoad[title] = false;
    }
  });

  $(document).on('mouseenter', 'header .navbar-subnav > .nav-item > .nav-link', function submenuLinkMouseEnter() {
    $('.navbar-subsubnav.--active').removeClass('--active');
    $('.nav-link.--hover').removeClass('--hover');
    $(this).addClass('--hover');
    $(`.navbar-subsubnav[data-child_id=${$(this).data('child')}]`).addClass('--active');
  });

  $(document).on('mouseleave', 'header .navbar__wrapper', function submenuLinkMouseLeave() {
    $('.nav-link.--hover').removeClass('--hover');
    $('.navbar-subsubnav.--active').removeClass('--active');
  });

  $(document).on('click', '.navbar-toggler', function navbarTogglerClick(e) {
    e.preventDefault();
    App.fn.mobileMenuGen();

    if ($('html').hasClass('filters_open') || $('html').hasClass('sidebar_open')) {
      $('html').removeClass('filters_open').removeClass('sidebar_open');
      $('#menu_navbar .--open, #menu_settings .--open').removeClass('--open');
    } else {
      $('html').addClass('sidebar_open');
    }
    $('aside .navbar-subnav, aside .navbar-subsubnav, aside, #menu_settings form').scrollTop(0);
    return false;
  });

  $(document).on('click', '.product__actions .--wishlist', function clickAddWishList() {
    const self = $(this);
    self.addClass('--loading');
    const request = `/basketchange.php?product=${self.data('product')}&size=uniw&mode=2&getAjax=true${
      self.hasClass('--observed') ? '&change=empty' : ''
    }`;

    $.ajax({
      type: 'GET',
      url: request,
      success: () => {
        Alert.show({
          text: self.hasClass('--observed') ? Literals.projector.removedWishes : Literals.projector.addedWishes,
          mod: '--success',
          duration: 1500,
        });
        const GetWhishes = new GetFunction();
        GetWhishes.Wishlist(({ Wishlist }) => {
          if (Wishlist.response && Wishlist.response.product.length) {
            $('.menu__link.--list').addClass('--active');
          } else {
            $('.menu__link.--list').removeClass('--active');
          }
        });
        GetWhishes.init();
        self.toggleClass('--observed');
        self.removeClass('--loading');
      },
    });
  });

  $(document).on('click', '.product .--cart', async function clickAddBasket(e) {
    e.preventDefault();
    const self = $(this);
    
    if (self.hasClass('--loading')) return;
    
    try {
      self.addClass('--loading');
      const productId = self.data('product');
      const data = `product=${productId}&size=uniw&number=1&getAjax=true`;
      const reload = self.hasClass('--reload');

      const { basket } = await $.ajax({
        type: 'POST',
        url: '/basketchange.php',
        data,
        dataType: 'JSON'
      });

      Alert.show({ 
        text: Literals.projector.addedProductBasket, 
        mod: '--success', 
        duration: 1500 
      });

      if (reload) {
        const basketForm = $('.basket__form');
        if (basketForm.length) {
          basketForm.submit();
        } else {
          location.reload();
        }
        return;
      }

      App.vars.expandableBasket.update({
        Basket: {
          response: { basket }
        }
      });
    } catch (error) {
      Alert.show({ 
        text: 'Wystąpił błąd podczas dodawania do koszyka', 
        mod: '--error', 
        duration: 2000 
      });
      console.error('Błąd dodawania do koszyka:', error);
    } finally {
      self.removeClass('--loading');
    }
  });
  $(document).on('change input focus blur', '.form-group .form-control, .f-group .f-control', App.fn.addFocused);

  setTimeout(() => {
    $('.form-group .form-control, .f-group .f-control').each(App.fn.addFocused);
    // TODO: Weryfikacja mechanizmu
    // $('.f-group .f-control.--validate-input').each(function validateAfterSomeTimeout() {
    //   if (this.value) {
    //     Validation.validateInput(this, this.dataset.validate);
    //   }
    // });
  }, 500);

  $('.f-group.--file .f-control').on('change', function fileInputChange() {
    const self = $(this);
    const sibling = self.siblings('.f-label');
    if (self.val().length) {
      sibling.addClass('--file');
      if (!sibling.attr('data-label')) {
        sibling.attr('data-label', sibling.text());
      }
      sibling.text(self.val());
    } else {
      sibling.removeClass('--file');
      sibling.text(sibling.attr('data-label'));
    }
  });

  App.fn.replaceSelects($('.f-select'), '', ($elem) => {
    App.fn.dropdownClick($elem, false);
  });

  App.fn.rwdBanner('#menu_banners2', [1, 2, 3, 4, 5]);

  App.vars.bLazy = new BLazy({
    breakpoints: [{ width: 420, src: 'data-src-small' }],
    offset: 500,
    success: function bLazySuccesFunc(element) {
      $(element).closest('.--skeleton').removeClass('--skeleton');
      $(element).parent().addClass('--loaded');
    },
  });

  App.vars.expandableBasket = new ExpandableBasket('.menu__dropdown-basket');

  Get.Wishlist(({ Wishlist }) => {
    if (!Wishlist) {
      return;
    }
    App.vars.Wishlist = Wishlist.response;
    if (Wishlist.response.product && Wishlist.response.product.length) {
      $('.menu__link.--list').addClass('.--active');
    }
  });
  Get.Snippets(
    ({ Snippets }) => {
      if (!Snippets) {
        return;
      }
      const snippets = Snippets.response.items;
      for (const key in snippets) {
        switch (snippets[key].region) {
          case 'head':
            $('head').append(snippets[key].content);
            break;
          case 'body_top':
            $('body').prepend(snippets[key].content);
            break;
          default:
            $('body').append(snippets[key].content);
            break;
        }
      }
    },
    {
      mobile: (App.vars.view == 1).toString(),
      tablet: (App.vars.view == 2).toString(),
      pc: (App.vars.view >= 3).toString(),
      request_uri: App.vars.request_uri,
      additional_ajax: App.vars.additional_ajax,
    },
  );
  Get.ToplayersAndWidgets(
    ({ ToplayersAndWidgets }) => {
      if (!ToplayersAndWidgets) {
        return;
      }
      const tAndW = ToplayersAndWidgets.response.items;
      for (const key in tAndW) {
        if (key === 'script') {
          eval(tAndW[key]);
        } else {
          $('body').append(tAndW[key].content);
        }
      }
    },
    {
      mobile: (App.vars.view == 1).toString(),
      tablet: (App.vars.view == 2).toString(),
      pc: (App.vars.view >= 3).toString(),
      request_uri: App.vars.request_uri,
      additional_ajax: App.vars.additional_ajax,
    },
  );

  const getCookiesProductData = async (id) => {
    const data = {
      Product: {
        format: 'json',
        params: {
          products: id,
        },
      },
    };
    const url = `/ajax/get.php?request=${JSON.stringify(data)}`;
    const resp = await fetch(url);
    const json = await resp.json();
    const {
      Product: {
        response: {
          product: [
            {
              attributes: { link },
              name,
              icon_small,
              price: {
                attributes: { price_formatted },
              },
            },
          ],
        },
      },
    } = json;
    return {
      link,
      name,
      icon_small,
      price_formatted,
    };
  };

  $(document).ready(function () {
    const userInfo = Cookie.get('login');
    const cookiesBar = Cookie.get('ck_cook');
    if (userInfo) {
      $('#ck_dsclr_v2').addClass('d-none');
    } else if (cookiesBar !== 'yes') {
      const cookiesProduct = $('.c-product').attr('data-id');
      if (cookiesProduct) {
        getCookiesProductData(cookiesProduct).then((data) => {
          const { link, name, icon_small, price_formatted } = data;
          $('.c-product__icon').html(`<img src="${icon_small}" alt="${name}">`);
          $('.c-product__name, .c-product__icon').attr({
            href: link,
            title: name,
          });
          $('.c-product__name').text(name);
          $('.c-product .btn, .c-product__link').attr('href', link);
          $('.c-product__price').text(price_formatted);
          $('.c-product').removeClass('--skeleton');
        });
      }
    }
  });

  App.run(
    () => {
      App.fn.mobileMenuGen(true);

      if ($('.navbar__wrapper .--bottom .--label').length) {
        $('.navbar__wrapper').each(function moveLabelToOtherPlaceEach() {
          const self = $(this);
          const link = self.find('.nav-product .--label');

          if (link.length) {
            self.find('.--bottom').append(link);
          }
        });
      }
    },
    [3, 4, 5],
    'body',
  );

  const Captcha = new Recaptcha('.--captchable');
  Captcha.setEventsInput();

  App.run(() => {
    if (!$('.navbar__wrapper .--bottom .--label').length) {
      $('.navbar__wrapper').each(function moveLabelToOtherPlaceEach() {
        const self = $(this);
        const link = self.find('.nav-product .--label');

        if (link.length) {
          self.find('.--bottom').append(link);
        }
      });
    }
  }, [1, 2]);

  App.run(
    () => {
      $('.newsletter .--top .f-group').after($('.newsletter .--consent'));
    },
    [1],
    '.newsletter',
  );

  App.run(
    () => {
      $('.newsletter .--top').after($('.newsletter .--consent'));
    },
    [2, 3, 4, 5],
    '.newsletter',
  );

  const BarsModule = new Bars();
  App.run(
    function () {
      BarsModule.init();
    },
    'all',
    'html:not(.order_process)',
  );

  App.run(
    () => {
      BarsModule.reset();
    },
    [1, 2, 3, 4, 5],
    'html:not(.order_process)',
  );

  App.run(function initOmnibusFallback() {
      if (typeof runOmnibusFallback === "function") {
        runOmnibusFallback();
      }
    },
    'all', 
    '[data-last_price_change_date]', 
    true
  );

};

export const AppInit = init;
